import React from 'react'
import SelectStatus from './SelectStatus';
import { TicketInterface } from '../../../../models/TicketModule/Ticket';

interface TicketSelectsProps {
    page: number;
    pageSize: number;
    ticket: TicketInterface;
}

export const TicketSelects: React.FC<TicketSelectsProps> = ({ ticket, page, pageSize }) => {
    return (
        <div className='ms-auto d-flex flex-column gap-1 me-5 mt-1'>
            <SelectStatus
                page={page}
                ticket={ticket}
                pageSize={pageSize}
                statusId={ticket.statusId}
            />
        </div>
    );
}
export default TicketSelects